import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { thunks as DownloadsThunks } from 'reducers/Downloads';

@connect()
class DownloadHandlerProvider extends React.Component {
	static propTypes = {
		release: PropTypes.object,
		song: PropTypes.object,
		dispatch: PropTypes.func,
		render: PropTypes.func
	}

	handleDownload = () => {
    const { dispatch, release, song } = this.props;

		if (release !== undefined) {
			dispatch(DownloadsThunks.addReleaseToDownloadQueue(release, 'mp3', 'download_handler_provider'));
		}
		if (song !== undefined) {
      if (song.assettype === 'video') {
        dispatch(DownloadsThunks.addVideoToDownloadQueue(song, 'download_handler_provider'));
      }
      else {
        dispatch(DownloadsThunks.addSongToDownloadQueue(song, { format: 'mp3', source: 'download_handler_provider' }));
      }
		}
	}

	render() {
		const { render } = this.props;
		return render({ handleDownload: this.handleDownload });
	}
}

export default DownloadHandlerProvider;
